export const MATRIX_APP_URL = process.env.REACT_APP_MATRIX_BASE_URL;
export const { REACT_APP_BACKEND_URL } = process.env;
export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
export const { REACT_APP_ORG_ID_6, REACT_APP_ORG_ID_24 } =
  process.env;
